import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(input: Array<any>, filterFunc): any[] {
    return input.filter(filterFunc);
  }
}
